import React from "react";
import Button from "../atoms/Button";
import styled from "styled-components";
import { useTranslation } from "react-i18next";

const StyledParagraph = styled.p`
  margin-bottom: 0;
`;

const ErrorModal = ({ message }) => {
  const { t } = useTranslation();

  return (
    <>
      <p>{message}</p>
      <StyledParagraph>
        <Button wide primary onClick={() => location.reload()}>
          {t("error_modal.retry")}
        </Button>
      </StyledParagraph>
    </>
  );
};

export default ErrorModal;
